import { Component } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { FeatureCardComponent } from '../freatureCard/featureCard';
import { cards }                from '../freatureCard/featureCardInterface';

@Component({
  selector: 'app-services-section',
  standalone: true,
  imports: [TranslocoModule, FeatureCardComponent],
  templateUrl: './services-section.html',
  styles: [`:host { display: block; }`],
})
export class ServicesSectionComponent {
  cards = cards;
}
